import { fetchData } from '../../Common/Data/DataFetcher.js';
import { getProUuid, fetchPro, getEmail, isImpersonated } from 'resources/Pro/ProData';
import AnalyticsApi from './AnalyticsApi.js';
import { fetchProPassword, isSalesAssistedSignup } from '../../Setup/api/SetupData';
import { isBlank } from 'utils/isBlank';
import { analytics } from 'external-libs/segment';

function getUuid() {
  return (dispatch, getState) => {
    let proUuid = getProUuid(getState());
    if (isBlank(proUuid)) {
      return dispatch(fetchData(fetchPro, {})).then(() => {
        proUuid = getProUuid(getState());
      });
    } else {
      return new Promise((resolve) => resolve(proUuid));
    }
  };
}

export function identify(properties = {}) {
  return (dispatch, getState) => {
    return dispatch(getUuid()).then((proUuid) => {
      properties.email = getEmail(getState());
      return analytics.identify(proUuid, properties);
    });
  };
}

export function groupWithIdentify(properties) {
  return (dispatch) => {
    return dispatch(identify(properties)).then(() => {
      AnalyticsApi.group(properties);
    });
  };
}

export function group(properties) {
  return () => {
    AnalyticsApi.group(properties);
  };
}

function getImpersonated() {
  return (dispatch, getState) => {
    let impersonated = isImpersonated(getState());
    if (impersonated === undefined) {
      return AnalyticsApi.getImpersonated()
        .then((response) => {
          return new Promise((resolve) => resolve(response.data));
        })
        .catch(() => {
          return new Promise((resolve) => resolve(false));
        });
    } else {
      return new Promise((resolve) => resolve(impersonated));
    }
  };
}

function getSalesAssisted() {
  return (dispatch, getState) => {
    let isSalesAssisted = isSalesAssistedSignup(getState());

    if (isSalesAssisted === undefined) {
      return dispatch(fetchData(fetchProPassword, {}))
        .then(() => {
          isSalesAssisted = isSalesAssistedSignup(getState());

          return new Promise((resolve) => resolve(isSalesAssisted));
        })
        .catch(() => {
          return new Promise((resolve) => resolve(false));
        });
    } else {
      return new Promise((resolve) => resolve(isSalesAssisted));
    }
  };
}

const getImpersonatedOrSalesAssisted = (useSalesAssisted) => {
  return async (dispatch) => {
    const impersonated = await dispatch(getImpersonated());

    if (useSalesAssisted) {
      const salesAssisted = await dispatch(getSalesAssisted());

      return salesAssisted || impersonated;
    }

    return impersonated;
  };
};

export function track(event, properties = {}, useSalesAssisted) {
  return (dispatch, getState) => {
    return dispatch(getImpersonatedOrSalesAssisted(useSalesAssisted)).then((impersonated) => {
      properties.pro_impersonated = impersonated;
      properties.email = getEmail(getState());

      return analytics.track(event, properties, { app: { version: window.APP_VERSION } });
    });
  };
}

export function trackPage(page, properties = {}, useSalesAssisted) {
  return (dispatch, getState) => {
    return dispatch(getImpersonatedOrSalesAssisted(useSalesAssisted)).then((impersonated) => {
      properties.pro_impersonated = impersonated;
      properties.email = getEmail(getState());
      return analytics.page(page, properties, {
        context: { screen: { height: window.screen.height, width: window.screen.width } },
      });
    });
  };
}
